import { NodeModel } from '@minoru/react-dnd-treeview';
import { Modal } from '../BaseModal';
import { AppContext } from '../../../context';
import { useContext, useState } from 'react';

interface Props {
    setModalOpen: (state: boolean) => void;
    isOpen: boolean;
    startDate: string;
    endDate: string;
    employee: NodeModel[];
    saveSubmit: (startDate: string, endDate: string, employeeIds: number[]) => void;
}

const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Asegura que el mes tenga dos dígitos
    const day = date.getDate().toString().padStart(2, '0'); // Asegura que el día tenga dos dígitos
    return `${year}-${month}-${day}`;
};

export const WorkshiftsSundaysUsualsModal = ({
    employee,
    endDate,
    isOpen,
    setModalOpen,
    startDate,
    saveSubmit,
}: Props) => {
    const { langResources } = useContext(AppContext);

    // Obtener fecha actual
    const currenDate = new Date();
    const currentMonth = currenDate.getMonth() + 1; // Mes actual (de 0 a 11)

    // Estado para almacenar la fecha inicial y final seleccionada
    const [InitialDate, setInitialDate] = useState<string | null>(null);
    const [finalDate, setFinalDate] = useState<string | null>(null);

    // Función para manejar el cambio de selección de mes
    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedMonth = parseInt(event.target.value);
        const selectedDate = new Date(
            currenDate.getFullYear(),
            selectedMonth - 1,
            1
        ); // Primer día del mes seleccionado
        const selectedEndDate = new Date(currenDate.getFullYear(), selectedMonth, 0); // Último día del mes seleccionado

        setInitialDate(formatDate(selectedDate));
        setFinalDate(formatDate(selectedEndDate));
    };

    // Crear opciones para el selector de meses
    const optionsListMonths: JSX.Element[] = [];
    for (let i = 1; i < currentMonth; i++) {
        optionsListMonths.push(
            <option key={i} value={i}>
                {new Date(currenDate.getFullYear(), i - 1, 1).toLocaleString(
                    'default',
                    { month: 'long' }
                )}
            </option>
        );
    }

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handlerSubmit = () => {
        if (InitialDate && finalDate) {
            saveSubmit(
                InitialDate,
                finalDate,
                employee.map((e) => Number(e.id))
            );
            setModalOpen(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalTitle={'validación de dominicales habituales.'}
            onClose={handleCloseModal}
            onSubmit={handlerSubmit}
            disableSubmit={!InitialDate || !finalDate}
            widthCustom='500px'
        >
            <div className='p-3'>
                <h4>Selecciona un mes:</h4>

                <select
                    className='form-control text-dark'
                    id='mesesSelector'
                    onChange={handleChange}
                >
                    {optionsListMonths}
                </select>
            </div>
        </Modal>
    );
};
